export default {
  en: {
    title: 'Speech accuracy',
    loadingChart: 'Loading chart',
    emptyState: 'Not enough data yet',
    percentNoErrors: '{{percent}}% error-free',
    repliesChecked: '{{count}} replies checked',
  },
  ru: {
    title: 'Корректность речи',
    loadingChart: 'Загружаю график',
    emptyState: 'Пока недостаточно данных',
    percentNoErrors: '{{percent}}% без ошибок',
    repliesChecked: '{{count}} реплик разобрано',
  },
  de: {
    title: 'Sprechgenauigkeit',
    loadingChart: 'Diagramm wird geladen',
    emptyState: 'Noch nicht genug Daten',
    percentNoErrors: '{{percent}}% fehlerfrei',
    repliesChecked: '{{count}} Antworten geprüft',
  },
  pt: {
    title: 'Precisão da fala',
    loadingChart: 'Carregando gráfico',
    emptyState: 'Ainda não há dados suficientes',
    percentNoErrors: '{{percent}}% sem erros',
    repliesChecked: '{{count}} respostas analisadas',
  },
  fr: {
    title: 'Précision orale',
    loadingChart: 'Chargement du graphique',
    emptyState: 'Pas encore assez de données',
    percentNoErrors: '{{percent}}% sans erreurs',
    repliesChecked: '{{count}} répliques analysées',
  },
  es: {
    title: 'Precisión al hablar',
    loadingChart: 'Cargando gráfico',
    emptyState: 'Todavía no hay suficientes datos',
    percentNoErrors: '{{percent}}% sin errores',
    repliesChecked: '{{count}} respuestas analizadas',
  },
};
